(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .directive('topicTagsListing', topicTagsListing);

  function topicTagsListing() {
    let directive = {
      restrict: 'E',
      templateUrl: '/templates/compliance_services/components/topic-tags-listing.directive.html',
      scope: {
        topics: '='
      }
    };

    return directive;
  }
})();
